import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type freeToStandardModalQuery,
	type JiraApplicationKey,
	type JiraProjectType,
} from './__generated__/freeToStandardModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	isConfluence: boolean;
	isJira: boolean;
	isServiceCollectionFree?: boolean;
	jiraApplicationKey: JiraApplicationKey;
	projectType: JiraProjectType;
};

type FreeToStandardModalComponent = EntryPointComponent<
	{
		freeToStandardModalQuery: freeToStandardModalQuery;
	},
	Record<string, never>,
	{
		onClose: () => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<FreeToStandardModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<FreeToStandardModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-free-to-standard-modal" */ './free-to-standard-modal',
			{
				moduleId: 'edition-awareness-free-to-standard-modal',
			},
		),
		getPreloadProps: ({
			cloudId,
			projectType,
			jiraApplicationKey,
			isJira,
			isConfluence,
			isServiceCollectionFree = false,
		}: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				freeToStandardModalQuery: {
					parameters,
					variables: {
						cloudId,
						jiraApplicationKey,
						projectType,
						isJira,
						isConfluence,
						isServiceCollectionFree,
					},
				},
			},
		}),
	});
